// extracted by mini-css-extract-plugin
export default {"controlsRow":"stockRequest_controlsRow__bLjmV","leftControl":"stockRequest_leftControl__3LimV","rightControl":"stockRequest_rightControl__lWvNg"};